import { Brain, MessageSquare, LineChart, Lightbulb } from '../icons';

const features = [
  {
    icon: Brain,
    title: '24/7 AI Personality Chat',
    description:
      'Talk to our AI companion — day or night — to get real-time insights about your personality traits and growth opportunities.',
  },
  {
    icon: MessageSquare,
    title: 'Daily Growth Tracking',
    description:
      'Quick, daily check-ins help you stay aware of your progress and maintain momentum on your personal development journey.',
  },
  {
    icon: Lightbulb,
    title: 'Personalized Insights & Tips',
    description:
      'Receive custom recommendations based on your unique profile to help you develop new skills and overcome challenges.',
  },
  {
    icon: LineChart,
    title: 'Progress Analytics',
    description:
      'Visual dashboards show your growth over time, helping you celebrate wins and identify areas for continued improvement.',
  },
];

export function NLPFeatures() {
  return (
    <section id="about" className="py-20 md:py-28 px-4 md:px-8 bg-nlp-cream/40">
      <div className="max-w-[1216px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-1/3">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full mb-4 border border-nlp-cream-dark">
              <span className="text-sm font-semibold text-nlp-forest">Features</span>
            </div>
            <h2
              className="text-3xl md:text-4xl font-bold text-nlp-forest mb-4"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              Features Designed for Your Growth
            </h2>
            <p className="text-lg text-nlp-taupe leading-relaxed">
              Explore tools that combine self-discovery and guided reflection to
              build healthier habits and a better mindset.
            </p>
          </div>

          <div className="lg:w-2/3 grid md:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl p-6 border border-nlp-cream-dark hover:shadow-lg transition-shadow"
              >
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-4 bg-nlp-olive/10">
                  <feature.icon className="w-6 h-6 text-nlp-olive" />
                </div>
                <h3 className="text-lg font-bold text-nlp-forest mb-2">
                  {feature.title}
                </h3>
                <p className="text-base text-nlp-taupe leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
